<div class="common-page-main">
  <div class="common-herobanner">
    <img src="assets/images/cpbanner.png" alt="">
  </div>
  <div class="right-sec common-right-sec">
    <div class="common-right-sec-bg">
      <div class="common-sec-heading">
        <h2>ABOUT WorldTumbLer</h2>
        <div class="common-btn-sec">
          <a class="btn btn-dark">Back</a>
        </div>
      </div>
      <div class="common-content">
        <p>Welcome to WorldTumbler, a collaborative mapping platform designed specifically for the tabletop role-playing
          game (TTRPG) community. Our journey as lifelong TTRPG enthusiasts began in 1979 with Dungeons & Dragons First
          Edition, expanding to include beloved classics like Top Secret, Car Wars, Call of Cthulhu, Gamma World,
          Champions, and the whimsical chaos of Cheapass Games.</p>
        <p>During long weekends, my best friend's parents, Barbara and Flash, would drive us from Santa Cruz,
          California, to Los Angeles. There, we would visit a hobby shop named "La Maison de Guerre," if I recall
          correctly. This trip was a significant event that occurred a few times a year and involved copious amounts of
          Coca-Cola, McDonald's meals, and sleep-deprived debates over tape measurements and home brew rules. Picture a
          mid-sized hobby store, display cases pushed aside to make room for six 4x8 plywood sheets, painted and stacked
          precariously with painted miniatures and reenactment battles. Being hobby shop, it was well-stocked and first
          assignment was unpacking another hundred cavalry (or which ever was needed) figures from inventory to showcase
          a newly assembled regiments. The popularity of Dungeons & Dragons in the late 80's brought magic and monsters
          into our miniature gaming experiences and I was hooked. Although times have changed, our love for gathering
          around tables for spirited discussions and cooperative objectives remains strong.</p>
        <p>Launched in 2019, WorldTumbler was created with a straightforward vision: to inspire shared storytelling and
          foster community connections. Drawing inspiration from the 1980s Judges Guild supplements—known for pairing
          detailed maps for game masters with blank maps for players—we aimed to recapture that sense of discovery while
          making it more accessible in today's digital landscape.
        </p>
        <p>At its heart, WorldTumbler emphasizes collaboration. Game Masters who design intricate worlds while players
          explore and interact with these creations. The community can share, remix, and build upon each other's ideas.
          Whether you're crafting a vast empire, a lively port town, or a concealed dungeon, WorldTumbler facilitates
          contributions to an evolving tapestry of shared worlds of any genre.</p>
        <p>We believe that the most enriching TTRPG experiences stem from collective imagination and storytelling.
          WorldTumbler is not merely a tool; it is meant to be a space where creators, players, and fans can share,
          inspire one another, and collaboratively shape worlds. Join us in cultivating a vibrant community where your
          maps and ideas ignite adventures for groups everywhere.</p>
      </div>
    </div>
  </div>


  <div class="right-sec common-right-sec">
    <div class="common-right-sec-bg">
      <div class="common-sec-heading">
        <h2>LEARN MORE</h2>
        <div class="common-btn-sec">
          <a class="btn btn-dark">Back</a>
        </div>
      </div>
      <div class="common-content">
        <h3>Overview</h3>
        <p>WorldTumbler is a Digital Mapping Platform for your fantasy worlds. Designed to revolutionize map-making for
          tabletop role-playing games (TTRPGs) across all genre's. Whether you're a Game Master leading epic quests, a
          player exploring uncharted realms, or a world builder designing a complex universe, WorldTumbler offers the
          ultimate solution for crafting immersive, interactive maps.</p>
        <p>With WorldTumbler, you can design breathtaking, multi-layered maps that bring your worlds to life. From
          sprawling continents to intricate dungeons, our intuitive interface and powerful tools empower creators of all
          skill levels to seamlessly build, share, and enhance their campaigns. Explore the future of TTRPG map-making
          and discover how WorldTumbler can elevate your storytelling. Learn More About Our Vision.</p>
        <p>At its core, WorldTumbler thrives on a vibrant, community-driven ecosystem. Players, Game Masters, and
          Creators can contribute to and explore shared worlds, each rich with unique geography, cultures, characters,
          adventures and interwoven storylines. Collaborate, connect, and discover endless opportunities as you immerse
          yourself in an ever-expanding tapestry of community-generated worlds and adventures.</p>
        <h3>Features</h3>
        <p>Help you craft interactive, layered maps filled with geographical data and customizable content. Incorporate
          dynamic elements like fog of war and map markers to bring your world to life while maintaining enough control
          over the gameplay experience.</p>
        <p>Leverage community-built content, including modules, NPCs, and pre-designed assets, to enhance your campaigns
          effortlessly. Collaborate with others or draw inspiration from a library of shared creations to make your
          adventures even more engaging.</p>
        <p>Our multi-layer system offers Game Masters the power to toggle between player and GM-only views, keeping
          surprises intact and adding depth to every session. Link lore, quests, and character notes directly to map
          elements for seamless integration, and track your campaign's progress with tools that organize your storyline
          chronologically. Explore the ultimate platform for immersive TTRPG storytelling. Explore All Features.</p>
        <h3>Benefits</h3>
        <p>WorldTumbler transforms your TTRPG experience with dynamic, interactive maps that bring your world to life
          and capture the essence of your gameplay narrative. While traditional VTTs focus on the finer points of
          combat, WorldTumbler takes a broader approach, enriching the immersive world-building that supports and
          enhances those VTT systems. </p>
        <p>Save time with automation tools like terrain generation, asset libraries, and map templates. Focus more on
          storytelling and gameplay while the platform handles the heavy lifting. See How It Saves Time</p>
        <h3>Use Cases</h3>
        <p>For Game Masters: Plan intricate campaigns, build battle maps, and manage exploration areas with ease. Use
          visibility layers to unveil secrets only when the story demands it, keeping players intrigued and immersed.
        </p>
        <p>For Players: Navigate the world like never before. WorldTumbler offers an engaging way to explore,
          strategize, and interact with the game world, making every session memorable. See Use Cases</p>
        <h3>Support</h3>
        <p>Send email to Support&#64;worldtumbler.com and we'll do our best to work with you!<br>
          We're constantly improving the platform and welcome your feedback. Hoping to have a roadmap posted soon.<br>
          About Us<br>
          WorldTumbler are passionate TTRPG enthusiasts dedicated to creating tools that enhance storytelling and bring
          fantasy worlds to life.<br>
          Our mission is to empower creators with innovative features that save time and elevate gameplay.<br>
          Founded by gamers for gamers, owe understand the challenges (and joys) of TTRPGs.<br>
          We are committed to building a supportive community and delivering the best mapping experience possible.</p>
        <h3>Acknowledgement</h3>
        <p>We extend our gratitude to a few creators and ask that you support these in their ongoing effort to make your
          worlds better.</p>
        <p>-- Azgaar! Creator of Azgaar's Fantasy Map Generator
          <https: //azgaar.github.io/Fantasy-Map-Generator /> - An open-source tool that enables users to design,
          modify, and personalize intricate fantasy maps, utilizing a wide array of generative options including
          terrain, culture, religion, and political features. Patreon: Azgaar's Patreon <https:
            //www.patreon.com/c/watawatabou/posts>
        </p>
        <p>-- Watabou! Creator of Procgen Arcana
          <https: //watabou.github.io /> - A collection of free, actively developed map generators designed for tabletop
          role-playing games and worldbuilding, featuring various tools to create diverse environments like cities,
          villages, and dungeons. Patreon: Watabou's Patreon <https: //www.patreon.com/c/watawatabou/posts>
        </p>
        <p>Their work and innovative tools have inspired and supported countless creators in the TTRPG community,
          including WorldTumbler. If you appreciate their contributions, please consider supporting them! Together,
          we're building incredible worlds.</p>
      </div>
    </div>
  </div>



</div>


<div class="right-sec common-right-sec">
  <div class="common-right-sec-bg">
    <div class="common-sec-heading">
      <h2>LEARN MORE</h2>
      <div class="common-btn-sec">
        <a class="btn btn-dark">Back</a>
      </div>
    </div>
    <div class="common-content">
      <div class="">
        <h5>What is WorldTumbler?</h5>
        <p>See our About page. LINK</p>
      </div>
      <div class="">
        <h5>Who can use this platform?</h5>
        <p>The platform is designed for all involved in TTRPG - Game Masters, Players, World Builders and Content
          Creators.</p>
      </div>
      <div class="">
        <h5>System requirements?</h5>
        <p>Internet connection and browser (Chrome recommended).</p>
      </div>
      <div class="">
        <h5>Is WorldTumbler compatible with all TTRPG systems?</h5>
        <p>The platform supports systems like D&D, Pathfinder, etc but can easily extend to other game systems.
          WorldTumbler is game system-agnostic as the ‘Game System' selected serves as a filter for world content
          displayed on a map. </p>
      </div>
      <div class="">
        <h5>Do I need prior cartography or design experience to use the platform?</h5>
        <p>Nope!. As a GM you can create a game in less than 5 minutes. Starting the game after creating is a two click
          process. Players populate their character page and join the game in under 5 minutes.</p>
      </div>
      <div class="">
        <h5>Can I upload my own assets?</h5>
        <p>Yes! Anyone can upload assets, modules, NPC's, characters, Markers. Subscription is required to add world
          maps.</p>
      </div>
      <div class="">
        <h5>Does the platform support collaborative editing?</h5>
        <p>Sort of. Anyone in the community can upload content to WorldTumbler maps however only a map owner can
          officially “edit” a map. GMs and players can work on a map simultaneously and specific information is shown at
          specific times to the different groups/individuals.</p>
      </div>
      <div class="">
        <h5>Are the maps interactive?</h5>
        <p>Yes, WorldTumbler is a digital mapping platform where you trace your journey, add journal entries, create
          NPC's, add adventure content / modules, that others can see on the map. Interactivity consists of these items
          plus landmark pins, notes, and map reveals during gameplay.</p>
      </div>
      <div class="">
        <h5>What kind of visibility controls are available?</h5>
        <p>Big topic - Ask that you take a look around.</p>
        <p>GMs can see the world map, move the game token and add content where they choose.</p>
        <p>Players are limited in their view through a fog of war based on the party. They can add details to the
          journey line and add content.</p>
        <p>Everyone can look around WorldTumbler sponsored maps.</p>
        <p>Uploaded maps will only be visible to the subscriber and invited players of that map. Areas, adventures, etc
          will be discovered while playing through fog of war.</p>
        <p>Open to your suggestions of course!</p>
      </div>
      <div class="">
        <h5>Does it support mobile and tablet use?</h5>
        <p>Current version is designed for desktop and tablets. You can use it on small devices but it might not look
          pretty. </p>
      </div>
      <div class="">
        <h5>Can I create custom geography, cultures, and religions?</h5>
        <p>Subscribers at certain level can upload maps created in Azgaar's Fantasy Map Generator (AFMG).
          <LINK>. AFMG allows editing Geography, Biome, Religion, Cultures, and more. Editing needs to occur before
          uploading to the WorldTumbler system. Keep a copy of your map!
        </p>
      </div>
      <div class="">
        <h5>Can I create custom cities?</h5>
        <p>Not yet... We are considering a way for subscribers who have uploaded world maps to replace city maps prior
          to any content being added in that city. It would be problematic to the characters timeline to change the map
          after content is added.</p>
      </div>
      <div class="">
        <h5>Are there pre-made templates or assets available?</h5>
        <p>Maps - WorldTumbler has published a sponsored world called Ashmorrow. Ashmorrow can be found in the Game
          Master -> Maps list and should be the map for all games during public beta. Content - As the community creates
          content it becomes available for use. Add a Wizarding shop in a berg labeled as D&D 5e content when an
          adventure party ride through that city the shop map marker appears. Add a chain of Inn called the Wanderers
          Haven that is in most every major city, abandoned wilderness temple, start building!</p>
      </div>
      <div class="">
        <h5>Does the platform use generative AI for Characters?</h5>
        <p>We respect artists and let the user decide. AI tokens are included in all membership levels and we ask you
          before generating AI content. If you create a character for instance and click the generate button for a
          character image, a pop-up window lets you know this will consume an AI token and stepping into the generative
          AI. If you say no and upload your own picture thats perfectly fine. Do you prefer Texas ribs or a St Louis
          ribs? If you have ideas we are open.</p>
      </div>
      <div class="">
        <h5>Does the platform use generative AI for Worlds:</h5>
        <p>This is a more difficult topic as Worlds are vast. WorldTumbler, as well as Azgaar's FMG and Watabou's
          Procgen Arcana use extensive programatic work to generate maps, cities, resources, industries, etc. However
          when you upload a map that has 20 religions, 10 cultures, 15 Political States, 200 burgs we offer the AI
          tokens to help you out. We use AI prompts to create information based on all the programatic data. We approach
          this as a template allowing the community, the opportunity to improve the work in what we hope will be a wiki
          style community editing approach.</p>
      </div>
      <h3>Sharing:</h3>
      <div class="">
        <h5>Can I share my maps with others?</h5>
        <p>Exactly the point. You can upload your map(s) and digital content and invite people to play in games where
          you are the GM. We are working to allow Map owners to invite other GM's to run games in subscriber maps.</p>
      </div>
      <div class="">
        <h5>How do I publish content to the platform's community?</h5>
        <p>We make it simple. WorldTumbler is designed around the community, so adding content is simple and everyone
          can participate from day 1.</p>
        <p>From all subscription level when in a map window simply Right click and select create content. Walk through
          the steps, upload maps/descriptions if appropriate and, Viola!</p>
        <p>Our hope is that the community will create living, breathing worlds that can be shared by all. That being
          said, several ways to share content include.</p>
      </div>
      <div class="">
        <h5>Can I export maps to use offline?</h5>
        <p>No. The secrete sauce is in the online community.</p>
      </div>
      <div class="">
        <h5>Does the platform support importing existing maps?</h5>
        <p>AFMG maps v1.106.7 or later. While we beta this feature we might need to help as its a hefty process.</p>
      </div>
      <div class="">
        <h5>What happens to my content and maps if I cancel my subscription?</h5>
        <p>We prioritize a chronological Character storyline. Here is what we do to preserve that storyline on account
          downgrades.</p>
        <p>All subscription levels can support content so this information remains tied to your account.</p>
        <p>Characters will be placed back into the players character compendium with an ‘orphaned' map identifier. We
          are working on allowing.</p>
        <p>Characters moving from Map to Map is on the roadmap and will be announced when ready.</p>
        <p>Journal entries will be transferred to individual character so chronological storyline is maintained.</p>
        <p>Uploaded subscriber Maps, Games, NPC running on the map will be deleted Content created will be orphaned and
          remain tied to the account and available in public content search.</p>
        <p>During downgrade, If you exceed the number of characters allowed at your new subscription level you will be
          asked to delete characters.</p>
        <p>During downgrade, If you exceed the number of Games allowed at your new subscription level you will be asked
          to delete games.</p>
      </div>
      <div class="">
        <h5>What are the pricing plans?</h5>
        <p>Please see the subscription page.</p>
      </div>
      <div class="">
        <h5>Is there a free trial?</h5>
        <p>Everyone gets Adventurer tier for free! Maintain a couple characters, run a game, create lots of content.</p>
      </div>
      <div class="">
        <h5>How can I get help if I have an issue?</h5>
        <p>There are several community support options for assistance. Look to:</p>
        <p>Discord servers</p>
        <p>Reddit</p>
      </div>
      <div class="">
        <h5>Can I request new features?</h5>
        <p>Yes, look to the Discord channel for the new Features.</p>
      </div>
    </div>
  </div>
</div>


<div class="right-sec common-right-sec">
  <div class="common-right-sec-bg">
    <div class="common-sec-heading">
      <h2>SUBSCRIPTIONS</h2>
      <div class="common-btn-sec">
        <a class="btn btn-dark">Back</a>
      </div>
    </div>
    <div class="common-content">


      <div class="cards">
        <div class="card">
          <img src="assets/images/subscription-img1.png" alt="Adventurer">
          <span>Adventurer</span>
        </div>
        <div class="card">
          <img src="assets/images/subscription-img2.png" alt="Surveyor">
          <span>Surveyor</span>
        </div>
        <div class="card">
          <img src="assets/images/subscription-img3.png" alt="Architect">
          <span>Architect</span>
        </div>
        <div class="card">
          <img src="assets/images/subscription-img4.png" alt="Creator">
          <span>Creator</span>
        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th></th>
            <th>Adventurer</th>
            <th>Surveyor</th>
            <th>Architect</th>
            <th>Creator</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Join Games</td>
            <td>YES</td>
            <td>YES</td>
            <td>YES</td>
            <td>YES</td>
          </tr>
          <tr>
            <td>Create Modules</td>
            <td>UNLIMITED</td>
            <td>UNLIMITED</td>
            <td>UNLIMITED</td>
            <td>UNLIMITED</td>
          </tr>
          <tr>
            <td>Characters</td>
            <td>2</td>
            <td>6</td>
            <td>10</td>
            <td>40</td>
          </tr>
          <tr>
            <td>Retired NPC</td>
            <td>50</td>
            <td>200</td>
            <td>1000</td>
            <td>UNLIMITED</td>
          </tr>
          <tr>
            <td>Create Games</td>
            <td>1</td>
            <td>3</td>
            <td>5</td>
            <td>10</td>
          </tr>
          <tr>
            <td>AI Generation Tokens</td>
            <td>10</td>
            <td>40</td>
            <td>200</td>
            <td>500</td>
          </tr>
          <tr>
            <td>Wiki Access</td>
            <td>YES</td>
            <td>YES</td>
            <td>YES</td>
            <td>YES</td>
          </tr>
          <tr>
            <td>Worldtumbler Maps</td>
            <td>YES</td>
            <td>YES</td>
            <td>YES</td>
            <td>YES</td>
          </tr>
          <tr>
            <td>Create Maps</td>
            <td>NO</td>
            <td>NO</td>
            <td>1</td>
            <td>5</td>
          </tr>
          <tr>
            <td>In-Game Journaling</td>
            <td>YES</td>
            <td>YES</td>
            <td>YES</td>
            <td>YES</td>
          </tr>
          <tr>
            <td>Journal Delegation</td>
            <td>NO</td>
            <td>YES</td>
            <td>YES</td>
            <td>YES</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td><button class="btn btn-dark">Upgrade</button></td>
            <td><button class="btn btn-dark">Upgrade</button></td>
            <td><button class="btn btn-dark">Upgrade</button></td>
          </tr>
        </tbody>
      </table>

      <p class="note">* You can join games as long as player has characters/slot available</p>
    </div>
  </div>
</div>